<pp-modal [ppNoPadding]="true">
  <ng-container heading>
    {{ 'bulk_changes_custom_fields' | ppTranslate }}
  </ng-container>

  <ng-container body>
    @for (fieldId of workspace.customFields; track fieldId) {
      <form
        class="modal-section__container"
        name="bulkFieldsForm{{ customFieldsData[workspaceId][fieldId]?.label }} "
      >
        @switch (customFieldsData[workspaceId][fieldId].type) {
          @case (customFieldTypes.TEXT) {
            <pp-bulk-field-text
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-text>
          }
          @case (customFieldTypes.DATE) {
            <pp-bulk-field-date
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppFieldId]="fieldId"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-date>
          }
          @case (customFieldTypes.LIST) {
            <pp-bulk-field-list
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppFieldId]="fieldId"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-list>
          }
          @case (customFieldTypes.MULTI_LIST) {
            <pp-bulk-field-multi-list
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppFieldId]="fieldId"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-multi-list>
          }
          @case (customFieldTypes.COST) {
            <pp-bulk-field-cost
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppFieldId]="fieldId"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-cost>
          }
          @case (customFieldTypes.PERCENTAGE) {
            <pp-bulk-field-percentage
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppFieldId]="fieldId"
              [ppWorkspaceId]="workspaceId"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-percentage>
          }
          @case (customFieldTypes.TIMELINE) {
            <pp-bulk-field-timeline
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppFieldId]="fieldId"
              [ppWorkspaceId]="workspaceId"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-timeline>
          }
          @case (customFieldTypes.TIME) {
            <pp-bulk-field-time
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppFieldId]="fieldId"
              [ppWorkspaceId]="workspaceId"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-time>
          }
          @case (customFieldTypes.NUMBERS) {
            <pp-bulk-field-numbers
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppFieldId]="fieldId"
              [ppWorkspaceId]="workspaceId"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-numbers>
          }
          @case (customFieldTypes.RICHTEXT) {
            <pp-bulk-field-rich-text
              [ppWorkspaceId]="workspace.workspaceId"
              [ppMentions]="mentions"
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppFieldId]="fieldId"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-rich-text>
          }
          @case (customFieldTypes.CHECKBOX) {
            <pp-bulk-field-checkbox
              [ppWorkspaceId]="workspace.workspaceId"
              [ppCustomField]="customFieldsData[workspaceId][fieldId]"
              [(ppCustomFieldsExtended)]="customFieldsExtended"
              [(ppCustomFields)]="customFields"
              [ppFieldId]="fieldId"
              [ppDisabled]="!editableCustomFieldIds.includes(fieldId)"
            ></pp-bulk-field-checkbox>
          }
        }
      </form>
    }
  </ng-container>

  <ng-container footer>
    <pp-modal-generic-footer
      [ppConfirmText]="'save' | ppTranslate"
      [ppProcess]="processing"
      (ppCancel)="hideModal()"
      (ppConfirm)="save()"
    ></pp-modal-generic-footer>
  </ng-container>
</pp-modal>
